import type LoanDataService from '../../features/loan/loan.data-service';
import type {IHttpResponse, IPromise} from 'angular';
import type {ActionResponse, Identified} from 'typings/portaro.be.types';

export default class LoanReadyNoticeToSendQuestionController {
    public static readonly controllerName = 'LoanReadyNoticeToSendQuestionController';

    private submitPromise: (promise: IPromise<ActionResponse | IHttpResponse<ActionResponse>> | Promise<ActionResponse>) => any;

    public init(submitPromise: (promise: IPromise<ActionResponse | IHttpResponse<ActionResponse>> | Promise<ActionResponse>) => any): void {
        this.submitPromise = submitPromise;
    }

    /*@ngInject*/
    constructor(private loanDataService: LoanDataService
    ) {
    }

    public processLoan(loan: Identified<string>, exemplar: Identified<number>): void {
        this.submitPromise(this.loanDataService.processLoan(loan.id, exemplar.id));
    }
}
